module.exports = __webpack_public_path__ + "static/img/10017.4da13cf8.png";